import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Modal} from "react-bootstrap";
import "../ViewAllArticles/ViewAllArticles.css";
import parse from "html-react-parser";

class ArticleView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,

        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

    }

    handleClose = () => {
        this.setState({
            show: false,

        });
    };

    handleShow = () => {
        this.setState({
            show: true,
        });

    };

    render() {
        return (
            <span>
                <a className="btn btn-xs btn-success article-btn" onClick={this.handleShow}>
                     {/*<FormattedMessage id="app.article-row.view"*/}
                                       {/*defaultMessage="View"*/}
                                       {/*description=""/>*/}

                                       確認

                </a>

                <Modal show={this.state.show} onHide={this.handleClose} dialogClassName ="article-view-modal-resp-admin">
                    <form onSubmit={this.onSubmit}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                <FormattedMessage id="app.admin-article-view.title"
                                                  defaultMessage="View Article"
                                                  description=""/>

                            </div>
                        </Modal.Header>
                        <Modal.Body>
                             <div className="row color-text">
                                 <div className="inquiry-reply-row-margin">
                                     <div className="col-md-2">
                                        <div className="text-right ">
                                            <label>
                                               <FormattedMessage id="app.admin-article-view.date"
                                                                 defaultMessage="Created Date"
                                                                 description=""/>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-10 no-padding-left resp-padding">
                                         {this.props.articleData.createdDate.substring(0,4)} 年 {this.props.articleData.createdDate.substring(5,7)} 月 {this.props.articleData.createdDate.substring(8,10)} 日
                                    </div>
                                    </div>
                            </div>
                            <div className="row color-text">
                                 <div className="inquiry-reply-row-margin">
                                     <div className="col-md-2">
                                        <div className="text-right ">
                                            <label>
                                                <FormattedMessage id="app.article-view.author"
                                                                  defaultMessage="Created By"
                                                                  description=""/>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-10 no-padding-left resp-padding">
                                        {this.props.author}
                                    </div>
                                    </div>
                            </div>
                        <div className="row color-text">
                            <div className="inquiry-reply-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right ">
                                        <label>
                                            <FormattedMessage id="app.article-view.title"
                                                              defaultMessage="Title"
                                                              description=""/>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left resp-padding">
                                    {this.props.articleData.title}
                                </div>
                            </div>
                        </div>
                            <div className="row color-text">
                            <div className="inquiry-reply-row-margin">
                                    <div className="spacer"></div>
                                    <div className="col-md-offset-1 resp-padding article-view-div" id="html-ing">
                                        {parse(this.props.articleData.articleContent)}
                                    </div>

                            </div>
                        </div>
                            <div className="row"></div>

                        </Modal.Body>
                        <Modal.Footer>
                            <div className="view-inquiry-div">
                                <a className="btn btn-default bottom-button" onClick={this.handleClose}>
                                   <FormattedMessage id="app.article-view.close"
                                                     defaultMessage="Close"
                                                     description=""/>
                                </a>
                            </div>
                        </Modal.Footer>
                    </form>
                </Modal>
            </span>
        )
    }

}

export default ArticleView;


// WEBPACK FOOTER //
// ./src/components/Admin/Articles/ArticleView/ArticleView.js